exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lookup-popup-container {\r\n    background: #F0F0F0;\r\n}\r\n.lookup-popup-container .search-filter-block {\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n}\r\n.lookup-popup-container .lookup-popup-divider {\r\n    margin: 0px;\r\n}\r\n.lookup-popup-container .search-results-title {\r\n    /* LFWM-2625 - lookup alignment changes */\r\n    padding-left: 24px;\r\n    color: #12408B;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/popup/lookup-popup.component.css
// module id = ../../../../../src/app/shared/lookup/popup/lookup-popup.component.css
// module chunks = main